import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../context/AuthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useTodayAttendance = (infinityCode) => {
  const [todayAttendance, setTodayAttendance] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTodayAttendance = useCallback(async () => {
    try {
      if (!infinityCode) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      const today = new Date().toISOString().split("T")[0];
      const response = await apiFetch(
        `${BASE_URL}/attendance/${infinityCode}/day?date=${encodeURIComponent(today)}`,
        { method: "GET" }
      );

      if (!response || !response.ok) {
        setTodayAttendance(null);
        setError("Failed to fetch attendance data");
        return;
      }

      const result = await response.json();
      if (result.success && result.data) {
        setTodayAttendance(result.data);
        setError(null);
      } else {
        setTodayAttendance(null);
        setError("No attendance data available");
      }
    } catch (err) {
      console.error("Error fetching today's attendance:", err);
      setTodayAttendance(null);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, [infinityCode]);

  useEffect(() => {
    fetchTodayAttendance();
    
    // Set up interval to refresh every 30 seconds
    const interval = setInterval(fetchTodayAttendance, 30000);
    return () => clearInterval(interval);
  }, [fetchTodayAttendance]);

  const hasTodayCheckIn = Boolean(
    todayAttendance?.checkIn && 
    String(todayAttendance.checkIn).trim() !== "" && 
    String(todayAttendance.checkIn).trim() !== "-"
  );

  const hasTodayCheckOut = Boolean(
    todayAttendance?.checkOut && 
    String(todayAttendance.checkOut).trim() !== "" && 
    String(todayAttendance.checkOut).trim() !== "-"
  );

  return {
    todayAttendance,
    isLoading,
    error,
    hasTodayCheckIn,
    hasTodayCheckOut,
    checkInTime: todayAttendance?.checkIn || null,
    checkOutTime: todayAttendance?.checkOut || null,
    refetch: fetchTodayAttendance,
  };
};
